import { useMutation, UseMutationOptions } from '@tanstack/react-query';

import {
    type CategoryRequest,
    type CategoryBillingQuestionsResponse,
    fetchCategoryBillingQuestions,
} from '../../services/categories';

export const useCategoryBillingQuestions = (
    props?: UseMutationOptions<CategoryBillingQuestionsResponse, unknown, CategoryRequest, unknown>,
) => {
    return useMutation<CategoryBillingQuestionsResponse, unknown, CategoryRequest, unknown>({
        mutationFn: async (input) => {
            return await fetchCategoryBillingQuestions(input);
        },
        ...props,
    });
};
